import Activity from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'studentId':
    case 'activityId':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new Activity(data).mapEntries(reviver);

export default create;




// WEBPACK FOOTER //
// ./data/WritingAssignment/Activity/create.js